import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import InsightVariants from "./variants";
import { useEffect, useState } from "react";
import { getBaseURL } from "src/config/api";
import { Alert } from "@material-ui/lab";
import { isJSONString } from "src/components/utils";
import { getTranslated } from "../utils/helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    height: "60vh",
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
}));

export const MassiveInsight = ({ columnDetails, hpoFilters, reportFiles }) => {
  const classes = useStyles();
  const [schema, setSchema] = useState(undefined);
  const [insightData, setInsightData] = useState([]);
  const [insightText, setInsightText] = useState(undefined);

  useEffect(() => {
    reportFiles["insight_tsv"] &&
      fetch(getBaseURL() + reportFiles["insight_tsv"].download_address)
        .then((response) => response.text())
        .then((data) => {
          const tmpData = [];
          let rows = data.split("\n");
          const headers = rows[0]
            .split("\t")
            .map((value) => value.toLowerCase());

          rows = rows.slice(1);

          rows.map((stringRow) => {
            if (stringRow.length > 0) {
              const row = stringRow.split("\t");
              let rowData = {};
              headers.forEach((header, index) => {
                rowData[header] = row[index];
              });
              tmpData.push(rowData);
            }
          });

          setInsightData(tmpData);
        });
  }, []);

  useEffect(() => {
    reportFiles["insight_txt"] &&
      fetch(getBaseURL() + reportFiles["insight_txt"].download_address)
        .then((response) => response.text())
        .then((data) => {
          if (isJSONString(data)) {
            setInsightText(JSON.parse(data));
          } else {
            setInsightText(data);
          }
        });
  }, []);

  useEffect(() => {
    if (!schema) {
      let tmpSchema = {};
      const tmpColumnDetails = columnDetails
        .filter((column) =>
          column.representation.options.hasOwnProperty("massive_insight")
        )
        .sort((columnA, columnB) => {
          const a = columnA.representation.options.massive_insight.order ?? 0;
          const b = columnB.representation.options.massive_insight.order ?? 0;
          return a - b;
        });

      for (const column of tmpColumnDetails) {
        if (column.representation.options.hasOwnProperty("massive_insight")) {
          tmpSchema = {
            ...tmpSchema,
            [column.name]: column,
          };
        }
      }

      setSchema({ ...tmpSchema });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return schema ? (
    <Box className={classes.center}>
      <Box className={classes.root}>
        <Box>
          <Alert severity="info">
            {getTranslated(insightText || "Massive Insight Not Found")}
          </Alert>
        </Box>
        {insightData.length > 0 &&
          <InsightVariants
            schemas={schema}
            insightData={insightData}
            hpoFilters={hpoFilters}
            setSchema={setSchema}
          />
        }
      </Box>
    </Box>
  ) : (
    <CircularProgress className={classes.buttonProgress} />
  );
};
